enum PropType {
  CHECKBOX_COUNT = 'checkboxCount',
  CHECKBOX_GROUP_MODE = 'checkboxGroupMode',
  DATA_LABEL = 'dataLabel',
  REQUIRED = 'required',
  TEXT_ALIGN = 'textAlign',
  TEXT_FONT_FAMILY = 'fontFamily',
  TEXT_FONT_SIZE = 'fontSize',
}

export default PropType;
